import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemSharedFiltersRoute: InvariantJiraRoute = {
	name: 'global-settings-system-shared-filters',
	path: '/secure/admin/filters/ViewSharedFilters.jspa',
};
